import { createFileRoute, Outlet } from '@tanstack/react-router';

import { ScrollArea } from '@components/ui/scroll-area';

export const Route = createFileRoute('/_layout')({
  component: Layout,
});

function Layout() {
  return (
    <ScrollArea className="h-dvh">
      <main className="bg-background min-h-dvh">
        <Outlet />
      </main>
    </ScrollArea>
  );
}
